/**
 * Version Info Hook
 *
 * Combines frontend and backend version information.
 * Backend version is fetched via tRPC, frontend version is build-time injected.
 */

import { trpc } from '@/trpc'
import { FRONTEND_VERSION } from '../version'

export interface VersionInfo {
  version: string
  buildDate: string
  commitSha: string
}

export interface CombinedVersionInfo {
  frontend: VersionInfo
  backend: VersionInfo | null
  isLoading: boolean
  error: Error | null
}

/**
 * Hook to get combined frontend and backend version information.
 *
 * @returns Combined version info with loading and error states
 */
export function useVersionInfo(): CombinedVersionInfo {
  const { data, isLoading, error } = trpc.system.getVersion.useQuery()

  return {
    frontend: FRONTEND_VERSION,
    backend: data ?? null,
    isLoading,
    error: error as Error | null,
  }
}
